import { Input } from '@apia/theme';
import { domPropsSelector } from '.';
import useDomProps from '../../../../store/selection/useDomProps';
import RowStatesRenderer from './renderers/RowStatesRenderer';
import { useResponsiveTableContext } from './ResponsiveTableContext';
import { TResponsiveTableRowState } from './types';

interface IStateCell {
  index: number;
  isHeader?: boolean;
  rowIndex: number;
  state?: TResponsiveTableRowState;
}

const StateCell = ({ index, rowIndex, state, isHeader }: IStateCell) => {
  const { name } = useResponsiveTableContext();
  const domProps = useDomProps(
    isHeader ? 'headerStateCell' : 'stateCell',
    { columnIndex: index, rowIndex },
    domPropsSelector(name),
  );
  return (
    <td className="stateCell" {...domProps}>
      {state ? (
        <RowStatesRenderer state={state} />
      ) : isHeader ? (
        <Input disabled />
      ) : (
        ''
      )}
    </td>
  );
};

export default StateCell;
